/// <reference path="../../ui/types.d.ts" />
import { FC } from 'react';

interface Owner {
    id: number;
    name: string;
}

interface ErrorPageProps {
    message: string;
    name?: string;
    owners?: Owner[] | null;
    hideActions?: boolean;
    allowLogout?: boolean;
    code?: number;
}

export const ErrorPage: FC<ErrorPageProps> = ({ message, name, owners, hideActions, allowLogout }) => {
    function integrationLogout() {
        checkOrigin()
            .then((queryParams) => fetch(`api/logout${queryParams}`, { method: 'POST' }))
            .then(checkResponse)
            .then(reloadLocation)
            .then(() => localStorage.removeItem(`revised_${name}`))
            .catch((e) => catchRejection(e, 'Looks like you are not logged in'));
    }

    function contactUser(userId: string | number) {
        AP.getContext(function (context) {
            AP.redirect(`${context.organization_id ? '/u' : ''}/messages/create/${userId}`);
        });
    }

    return (
        <div className="i_w">
            <div className="error-page">
                <div>
                    <div className="error-page-message">
                        <crowdin-h3>{message}</crowdin-h3>
                        {owners && (
                            <>
                                <crowdin-p>
                                    This integration allows only one connection per project to ensure consistent
                                    configuration and prevent file import or synchronization issues.
                                </crowdin-p>
                                {owners.length > 1 ? (
                                    <>
                                        <crowdin-p class="mt-2">Managed by:</crowdin-p>
                                        <ul>
                                            {owners.map((owner) => (
                                                <li>
                                                    <crowdin-a href="#" onClick={() => contactUser(owner.id)}>
                                                        {owner.name}
                                                    </crowdin-a>
                                                </li>
                                            ))}
                                        </ul>
                                        <crowdin-p class="mt-2">
                                            To request access, please contact one of the project members listed above.
                                        </crowdin-p>
                                    </>
                                ) : (
                                    <>
                                        <crowdin-p class="mt-2">
                                            Managed by:{' '}
                                            <crowdin-a href="#" onClick={() => contactUser(owners[0].id)}>
                                                {owners[0].name}
                                            </crowdin-a>
                                        </crowdin-p>
                                        <crowdin-p class="mt-2">
                                            To request access, please contact the project member listed above.
                                        </crowdin-p>
                                    </>
                                )}
                            </>
                        )}
                    </div>
                    {allowLogout && hideActions ? (
                        <crowdin-card light-filled>
                            <crowdin-alert
                                type="warning"
                                margin
                                message="Deleting the integration will disconnect it and reset its settings for this project."
                            />
                            <crowdin-button outlined onClick={() => integrationLogout()}>
                                Delete Integration
                            </crowdin-button>
                        </crowdin-card>
                    ) : (
                        !hideActions && (
                            <div className="error-page-action">
                                <crowdin-button outlined onClick={() => integrationLogout()}>
                                    Log out
                                </crowdin-button>
                                <span>
                                    {' '}
                                    or{' '}
                                    <crowdin-a href="https://crowdin.com/contacts" target="_blank">
                                        contact us
                                    </crowdin-a>{' '}
                                    for help
                                </span>
                            </div>
                        )
                    )}
                </div>
            </div>
        </div>
    );
};
